module.exports = __webpack_public_path__ + "static/media/uorg1.b0f6ffdd.png";